import './ApplyModal.scss';

import { Modal, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { api } from '../../../utils/api';

export default function ApplyModal({show, handleClose, job}) {
  const [details, setDetails] = useState("");

  // Reset details whenever the modal is opened
  useEffect(() => {
    if (show) {
      setDetails("");
    }
  }, [show]);

  const handleApply = async (updatedData) => {
    try {
      await api.post(`/users_job_postings`, {job_posting_id: job.id, details: details});
      handleClose();
    } catch (err) {
      // TODO(marco): design error state
      console.error("Failed to save profile:", err);
    }
  };

  return (
    <Modal className="__apply-modal" show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>We got you covered!</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="modal-subtitle">
          We will send your Papaya profile to this opportunity.
        </div>
        <Form>
          <Form.Group className="mb-3">
            <Form.Control
              value={details}
              as="textarea"
              rows={4}
              onChange={(e) => setDetails(e.target.value)}
              placeHolder="Anything else you want to share..."
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button className="ppy-btn ppy-btn-primary" onClick={handleApply}>Apply</Button>
      </Modal.Footer>
    </Modal>
  );
}
